// Liste des permissions disponibles dans le backend
export const PERMISSIONS = {
  CREATE_USER: "CREATE_USER",
  UPDATE_USER: "UPDATE_USER",
  DELETE_USER: "DELETE_USER",
  TRANSFER: "TRANSFER",
  REQUEST_PAYOUT: "REQUEST_PAYOUT",
  VIEW_TRANSACTIONS: "VIEW_TRANSACTIONS",
  MANAGE_COLLABORATORS: "MANAGE_COLLABORATORS",
  SEARCH_FILTER: "SEARCH_FILTER",
  VIEW_DASHBOARD: "VIEW_DASHBOARD",
  CREATE_PAYMENT_LINK: "CREATE_PAYMENT_LINK",
  CREATE_BUSINESS: "CREATE_BUSINESS",
  VIEW_PAYMENT_LINK: "VIEW_PAYMENT_LINK",
  VIEW_PAYOUT: "VIEW_PAYOUT",
  VIEW_TRANSFER: "VIEW_TRANSFER"
};
